import { ContentHeader } from "../../components";
import { Form, Button, Input, Row, Col, Table, Space, Checkbox, Radio, Tag } from 'antd';
import { DeleteOutlined, SaveOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import Column from 'antd/es/table/Column';
import { HeSoLuongResponse } from "../../models/danhmuc/DanhMuc";
import { layDanhMucHeSoLuongResponse, luuHeSoLuong, xoaHeSoLuong } from "@app/services/danhmuc";
import { layThongTinCauHinhLuong } from "@app/services/setting";
import ModalTextForm from "@app/components/modal/ModalTextForm";
import { toast } from "react-toastify";
import { currencyFormat, formatVND, validateMessages } from '../../helpers/common';
import BacLuongSelectBox from "../utils/BacLuongSelectBox";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import { searchLength } from "../../constants";

const QuanLyHeSoLuong = () => {
    const [data, setData] = useState<Array<HeSoLuongResponse>>([]);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [trangThaiFilter, setTrangThaiFilter] = useState<string>("tatca");
    const [page, setPage] = useState(1);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [mucLuongCoBan, setMucLuongCoBan] = useState<number>(0);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const setFormDetailModal = (value: HeSoLuongResponse | null) => {
        form.setFieldsValue({
            "id": value?.id || 0,
            "idBacLuong": value?.idBacLuong,
            "ten": value?.ten,
            "heSo": value?.heSo,
            "mucLuong": value?.mucLuong,
            "mucLuongStr": value?.mucLuong ? currencyFormat.formatMoney(value?.mucLuong) : "" || 0,
            "an": value?.an || false,
        });
        setShowModalChiTiet(true);
    }
    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            mucLuong: parsedValue,
            mucLuongStr: format
        });
    };

    const layDuLieu = async () => {
        try {
            setIsLoadingTable(true);
            let rs = await layDanhMucHeSoLuongResponse();
            let cauHinh = await layThongTinCauHinhLuong();
            setMucLuongCoBan(cauHinh?.mucLuongDongBH_NQL || 0);
            setData(rs);
            setIsLoadingTable(false);
        } catch (error: any) {
            setIsLoadingTable(false);
        };
    }

    const onDelete = async () => {
        try {
            setIsLoadingBtn(true);
            await xoaHeSoLuong(idXoa);
            toast.success('Xoá hệ số lương thành công!');

            // Tính toán số trang mới sau khi xóa
            const totalRecords = data.length - 1; // Số lượng bản ghi sau khi xóa
            let newPage = page;

            if (newPage > Math.ceil(totalRecords / searchLength)) {
                // Nếu trang hiện tại lớn hơn số trang mới tối đa
                newPage = Math.ceil(totalRecords / searchLength);
            }

            setPage(newPage);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setReloadPage(true);
        setIsLoadingBtn(false);
    }

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            await luuHeSoLuong(values);
            setShowModalChiTiet(false);
            toast.success('Lưu thông tin hệ số lương thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
        setReloadPage(true);
    };

    useEffect(() => {
        if (reloadPage) {
            layDuLieu();
            setReloadPage(false);
        }
    }, [reloadPage]);

    return (<section>
        <ContentHeader title="Quản lý danh mục hệ số lương" />
        {idXoa > 0 && <ModalTextForm show={idXoa > 0}
            title="Xoá hệ số lương"
            handleClose={() => setIdXoa(0)}
            handleSave={onDelete}>
            Xác nhận xóa hệ số lương đang chọn
        </ModalTextForm>}
        {showModalChiTiet && <ModalTextForm title="Quản lý hệ số lương "
            hideFooter
            show={showModalChiTiet}
            handleClose={() => setShowModalChiTiet(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="id"><Input /></Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="idBacLuong" label="Bậc lương">
                            <BacLuongSelectBox onChange={(e: any) => { form.setFieldValue('idBacLuong', e.target.value); }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Mức lương"
                            name="mucLuongStr"
                            rules={[
                                {
                                    required: true
                                }
                            ]}
                        >
                            <Input prefix="₫ " placeholder="Mức lương" onChange={handleChangeCurrency} />
                        </Form.Item>
                        <Form.Item name="mucLuong" hidden>
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Bậc"
                            name="ten" >
                            <Input placeholder="Bậc" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Hệ số"
                            name="heSo" >
                            <Input placeholder="Hệ số" onChange={(e) => {
                                form.setFieldValue('heSo', e.target.value);
                                const heSoVal = parseFloat(e.target.value.replace(',', '.')) || 0;
                                const newMucLuong = heSoVal * mucLuongCoBan;
                                form.setFieldsValue({
                                    mucLuong: newMucLuong,
                                    mucLuongStr: currencyFormat.formatMoney(newMucLuong.toString())
                                });
                            }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="an" valuePropName="checked">
                            <Checkbox>Ẩn</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <Row className="form-group" gutter={[8, 8]} align="middle">
            <Col xs={24} sm={12} md={7} lg={6}>
                <Input prefix={<SearchOutlined rev="" />} allowClear placeholder="Nhập từ khóa để tìm kiếm" onChange={(e) => {setPage(1); setTuKhoa(e.target.value)}} />
            </Col>
            <Col xs={24} sm={12} md={7} lg={6}>
                <Radio.Group
                    value={trangThaiFilter}
                    onChange={(e) => {
                        setTrangThaiFilter(e.target.value);
                        setPage(1);
                    }}
                    buttonStyle="solid"
                    size="middle"
                >
                    <Radio.Button
                        value="tatca"
                        style={{ borderRadius: '999px 0 0 999px', fontWeight: 500 }}
                    >
                        Tất cả
                    </Radio.Button>
                    <Radio.Button
                        value="dangsudung"
                        style={{ borderRadius: '0 999px 999px 0', fontWeight: 500 }}
                    >
                        Đang sử dụng
                    </Radio.Button>
                </Radio.Group>
            </Col>
            <Col xs={24} sm={12} md={6} lg={7}>
                <span style={{ fontWeight: 'bold', fontSize: '16px', color: '#d9534f', paddingLeft: '10px' }}>
                    Mức lương cơ bản: {formatVND(mucLuongCoBan)}
                </span>
            </Col>
            <Col xs={24} sm={12} md={4} lg={5}>
                <Button
                    className="hrm-btn hrm-btn-warning float-right"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data.map((item: any, index) => { item.key = index; return item; }).filter((record: HeSoLuongResponse) =>
                                (trangThaiFilter === 'tatca' || !record.an) &&
                                ((record.tenBacLuong || "").toLowerCase().includes(tuKhoa.toLowerCase()) || (record.ten || "").toLowerCase().includes(tuKhoa.toLowerCase())
                                    || (record.heSo || "").toString().toLowerCase().includes(tuKhoa.toLowerCase()) || formatVND(record.mucLuong).toLowerCase().includes(tuKhoa.toLowerCase())
                                    || (record.mucLuong || "").toString().toLowerCase().includes(tuKhoa.toLowerCase()))
                                )}
                                rowClassName={(record, index) => {
                                    return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                }}
                                pagination={{
                                    current: page,
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}
                            >
                                <Column
                                    width="5%"
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {(page - 1) * searchLength + index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column width="25%" title="Tên bậc Lương" dataIndex="tenBacLuong" key="tenBacLuong" />
                                <Column width="10%" title="Bậc" dataIndex="ten" key="ten" />
                                <Column width="10%" title="Hệ Số" dataIndex="heSo" key="heSo" />
                                <Column width="20%" title="Mức lương" key="mucLuong" render={(value, record, index) =>
                                (
                                    <>
                                        {formatVND(value?.mucLuong)}
                                    </>
                                )
                                }
                                />
                                <Column width="15%" title="Trạng thái" key="an" render={(value, record: HeSoLuongResponse) =>
                                (
                                    record?.an ? <Tag color="red">Đã ẩn</Tag> : <Tag color="green">Đang sử dụng</Tag>
                                )
                                }
                                />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <Space>
                                            <Button type="primary" size={"small"} title="Sửa"
                                                icon={<EditOutlined rev="" />}
                                                onClick={() =>{ setFormDetailModal(value); }}
                                            >
                                                Sửa
                                            </Button>
                                            <Button type="primary" danger size={"small"} title="Xóa"
                                                onClick={() => { setIdXoa(value.id) }}
                                                icon={<DeleteOutlined rev="" />}
                                            >
                                                Xóa
                                            </Button>
                                        </Space>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default QuanLyHeSoLuong;